import { input, Component } from '@angular/core';

@Component({
  selector: 'app-icon',
  imports: [],
  templateUrl: './icon.html',
  styleUrl: './icon.scss',
})
export class Icon {
  readonly icon = input.required<string>();
  readonly width = input<number>(24);
  readonly height = input<number>();
}
